import { whyChooseUs } from '../../data/mock';

const WhyChooseSection = () => (
  <div className="why-choose-section">
    <h2 className="section-title">Pourquoi Nous Choisir ?</h2>
    <div className="why-choose-content-wrapper">
      <div className="why-choose-layout">
        <div className="why-choose-list">
          {whyChooseUs.map((reason) => (
            <div key={reason.id} className="why-card">
              <h3 className="why-title !text-left">{reason.title}</h3>
              <p className="why-description !text-left">{reason.description}</p>
            </div>
          ))}
        </div>
        <div className="why-choose-image-container">
          <img 
            src="https://customer-assets.emergentagent.com/job_simple-web-pro/artifacts/3iv8ykt0_IMG_4024.jpg" 
            alt="Louis-Philippe de Lavage de Vitre Bois-Franc en action" 
            className="why-choose-image"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </div>
);

export default WhyChooseSection;
